import type { Localized } from '../types';

type NavItem = {
  readonly label: string;
  readonly to?: string;
  readonly href?: string;
};

type CommonContent = {
  readonly nav: readonly NavItem[];
  readonly footer: {
    readonly privacy: string;
    readonly contact: string;
  };
  readonly mapLabel: string;
};

export const commonDict: Localized<CommonContent> = {
  ja: {
    nav: [
      { label: 'サービス紹介', to: '/services' },
      { label: '会社概要', to: '/about' },
      { label: 'お問い合わせ', href: 'mailto:lisong@cji.jp' },
    ],
    footer: {
      privacy: 'プライバシーポリシー',
      contact: 'お問い合わせ',
    },
    mapLabel: '所在地マップ',
  },
  zh: {
    nav: [
      { label: '服务介绍', to: '/services' },
      { label: '公司简介', to: '/about' },
      { label: '联系我们', href: 'mailto:lisong@cji.jp' },
    ],
    footer: {
      privacy: '隐私政策',
      contact: '联系我们',
    },
    mapLabel: '所在地地图',
  },
};
